import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { formatFilterEmptyFields } from '@app/utils/filterUtils';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';

import { MediaFilter } from '@app/pages/Media/MediaFilter';

import { DebouncedInput } from '@app/components/ListHeader/ListSearch/DebouncedInput.tsx';
import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import './styles.css';

interface HeaderAddMediaProps {
  title: string;
  handleChangeFilters(filters: GenericObject): void;
}

export const HeaderAddMedia = ({ title, handleChangeFilters }: HeaderAddMediaProps) => {
  const [inputValue, setInputValue] = useState('');

  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      // Only allow the user to select from published videos
      statusType: 'ACTIVE',
    },
  });
  const isValidating = form.formState.isValidating;

  useEffect(() => {
    if (!handleChangeFilters) {
      return;
    }

    //Set null to empty fields to avoid empty strings
    const values = form.getValues();
    formatFilterEmptyFields(values);

    handleChangeFilters({ ...values, title: inputValue });
  }, [inputValue, handleChangeFilters, isValidating, form]);

  const handleChangeInputValue = (value: string) => {
    setInputValue(value);
  };

  return (
    <div className="list-header-media">
      <FormProvider {...form}>
        <form style={{ width: '100%' }}>
          <div style={{ display: 'flex', padding: 10, alignItems: 'center' }}>
            <Typography data-cy={title} variant="h3" sx={{ flex: 1 }}>
              {title}
            </Typography>
            <div>
              <DebouncedInput generalFilterLabel={'Search title'} handleChangeValue={handleChangeInputValue} />
            </div>
          </div>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
              <Typography sx={{ fontWeight: 'bold', color: '#2D3748' }}>FILTER</Typography>
            </AccordionSummary>
            <AccordionDetails>{<MediaFilter statusFilterDisabled />}</AccordionDetails>
          </Accordion>
        </form>
      </FormProvider>
    </div>
  );
};
